export default __webpack_public_path__ + "static/media/mandi.4ac6c268.png";